class VwPatolojiRaporislemleriDTO {
    id: number = 0;
    orderDetayId?: number = null;
    alinmaTarih?: string = null;
    dokuTemelOzellikId?: number = null;
    alinmaSekliId?: number = null;
    yerlesimYerId?: number = null;
    bulasiciVarMi?: string = "H";
    acil?: string = "H";
    talepAciklama?: string = "";
    ekleyenKullanici?: number = null;
    eklemeTarihi?: string = null;
    guncelleyenKullanici?: number = null;
    guncellemeTarihi?: string = null;
    iptal?: string = "H";
    iptalTarihi?: string = null;
    iptalKullanici?: number = null;
    materyalId?: number = null;
    materyalAdet?: number = null;
    klinikBilgi?: string = "";
    laboratuvarBilgi?: string = "";
    numunedurum?: number = null;
    fkTeslimedenpersonel?: number = null;
    muracaatId?: number = null;
    kimlikId?: number = null;
    hastaservisId?: number = null;
    organizasyonId?: number = null;
    servisId?: number = null;
    doktorId?: number = null;
    asistanId?: number = null;
    aciklama?: string = "";
    bagliOrganizasyonId?: number = null;
    doktorAdi?: string = "";
    servisAdi?: string = "";
    hastaAdiSoyadi?: string = "";
    yerlesimyeradi?: string = "";
    dokutemelozellikadi?: string = "";
    alinmasekiladi?: string = "";
    materyaladi?: string = "";
    rednedenadi?: string = "";
    teslimedenpersoneladsoyad?: string = "";
    teslimalanpersoneladsoyad?: string = "";
    hastaraporId?: number = null;
    protokolNo?: number = null;
    revizeno?: number = null;
    protokolOnek?: string = "";
    protokolYil?: number = null;
    protokolSira?: number = null;
    raportip?: number = null;
    orderId?: number = null;
    onaytarih?: string = null;
    raporTipTanimid?: number = null;
    protokolGosterim?: string = "";
    mailGonderildi?: string = "";
    mailGonderimTarihi?: string = "";
    rezervBarkodno?: number = null;
    icKurumBarkodNo?: string = "";
}
export default VwPatolojiRaporislemleriDTO;